
sap["ls"]["preload"]["UCF_LayeredControl"] = function() {/* global _assert, _trace, INFO, ERROR, WARNING */
/// <reference path="../../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../../core/util/JsUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../../core/util/UserAgent.js"/>
/* global UCF_Control */
/// <reference path="../../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../../core/LS.js"/>
/* global UCF_System */
/// <reference path="../../core/System.js"/>
/* global UCF_ChildLayerDelegate */
/// <reference path="./ChildLayerDelegate.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../../browser/BrowserEvent.js"/>

/**
 * Implements a layered control that offers certain features for positioning
 * and alignment to other controls.
 *
 * @class
 * @extends UCF_Control
 *
 * @param {HTMLElement} oDomRef the DOM element
 * @param {UCF_LS} oLS the LightSpeed instance
 */
function UCF_LayeredControl(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["UCF_LayeredControl"]++; }; 
	if (arguments["length"] > 0) {
		if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "LayeredControl.js(32): UCF_LayeredControl"); };

		UCF_Control["apply"](this, [oDomRef, oLS]);

		this["defineEvents"](['Close']);

		/** @type {number} */
		this["iOffsetLeft"] = 0; // eslint-disable-line @ur/no-memory-leaks
		/** @type {number} */
		this["iOffsetTop"] = 0; // eslint-disable-line @ur/no-memory-leaks
		/** @type {number} */
		this["iOverlap"] = 0; // eslint-disable-line @ur/no-memory-leaks
		/** @type {number} */
		this["iTop"] = null; // eslint-disable-line @ur/no-memory-leaks
		/** @type {number} */
		this["iLeft"] = null; // eslint-disable-line @ur/no-memory-leaks
		/** @type {boolean} */
		this["bOpened"] = false; // eslint-disable-line @ur/no-memory-leaks
		/** @type {HTMLElement} */
		this["oOpenerRef"] = null;
		/** @type {HTMLElement} Used only for parent - child layering (QuickView/Popover) */
		this["oOpenerRefForLayering"] = null;
		/** @type {number} */
		this["iOpenYDirection"] = 1;
		/** @type {HTMLElement} */
		this["oPlaceHolderRef"] = null;
		/** @type {boolean} layered control shall be horizontally moved to fit into the viewport */
		this["bMoveX"] = true; // eslint-disable-line @ur/no-memory-leaks
		/** @type {boolean} layered control shall be vertically moved to fit into the viewport */
		this["bMoveY"] = false; // eslint-disable-line @ur/no-memory-leaks
		/** @type {boolean} */
		this["bAlreadyDestroyed"] = false;
		/** @type {boolean} */
		// this.bParentLayerHandlerCalled = false;
		/** @type {number} */
		this["iSafetyDistance"] = 0; // eslint-disable-line @ur/no-memory-leaks

		this["reset"]();

		/**
		 * Default alignment, control may call setAlignment()
		 * @type {number}
		 */
		this["iAlignment"] = UCF_LayeredControl["ALIGNMENT"]["BOTTOMLEFT"]; // eslint-disable-line @ur/no-memory-leaks

		/**
		 * Algo. in setPosition() may switch to different alignment or
		 * calculate an additional offset
		 * @type {number}
		 */
		// this.iAlignmentResult = this.iAlignment;
		// /** @type {number} */
		// this.iLeftOffsetResult = 0;

		/**
		 * Default: no "parent" layered control
		 * @type {boolean}
		 */
		this["bIsParent"] = false;

		/**
		 * Currently opened child layer, e.g. PopupMenu inside QuickView
		 * @type {UCF_LayeredControl}
		 */
		this["oChildLayer"] = null;
		/** @type {number} */
		this["iChildLayerZIndex"] = -1; // eslint-disable-line @ur/no-memory-leaks
		/** @type {number} */
		this["iChildLayerZIndexIncrement"] = 0; // eslint-disable-line @ur/no-memory-leaks

		/** @type {Window} */
		this["oWindow"] = window;

		// Default zIndex
		if (this["oRootRef"]) {
			this["oRootRef"]["style"]["zIndex"] = UCF_LS["E_LAYERS"]["POPUPMENUS"];
		}
		// DOM-marker
		oDomRef["setAttribute"]('ls-layeredcontrol', 'X');

		/** @type {boolean} */
		this["bEnhancePopupWindow"] = false;
	}
};window["UCF_LayeredControl"] = UCF_LayeredControl; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_LayeredControl"); UCF_LayeredControl["_"] = {UCF_LayeredControl: 0}; }; ;
UCF_LayeredControl["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_LayeredControl.prototype["sClassName"] = "UCF_LayeredControl";

/**
 * Alignment of the layered control
 *
 * @constant
 * @enum {number}
 */
UCF_LayeredControl["ALIGNMENT"] = {
	"TOPLEFT": 0,
	"TOPRIGHT": 1,
	"BOTTOMLEFT": 3,
	"BOTTOMRIGHT": 4,
	"BROWSERCENTER": 5,
	"POSITION": 6,
	"MENUITEM": 7,
	"TOPLEFT_CONTAINER": 8,
	"TOPRIGHT_CONTAINER": 9,
	"TOPCENTER": 10,
	"BOTTOMCENTER": 11,
	"RIGHT": 12,
	"OVERLAY": 13 // full screen (e.g. used for phones)
};

/** @constant {string} */
UCF_LayeredControl["BOX_SHADOW_CLASS"] = 'lsLCDropShadow';

/** @constant {string} */
UCF_LayeredControl["PARENT_LAYER_OPEN"] = 'bIsParentLayerOpen';

/** @constant {number} */
UCF_LayeredControl["MIN_BORDER_DISTANCE"] = UCF_DomUtil["iRem2px"](0.5);

/** @override */
UCF_LayeredControl["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["destroy"]++; }; 
	if (!this["bAlreadyDestroyed"] && this["oRootRef"] != null) {
		if (this["oOpenerRef"]) {
			this["oOpenerRef"] = null;
		}
		this["bAlreadyDestroyed"] = true;
		if (this["bOpened"])
			this["notifyLayeredControlClose"]();
		// We have to release the blind-layer:
		// It is unspecified whether close() must be called before a destroy()
		// or if a control that extends LayeredControl must call close() in its
		// destroy implementation, or ...
		if (this["oBlindLayer"]) {
			this["oLS"]["releaseBlindLayer"](this["oBlindLayer"]);
			this["oBlindLayer"] = null;
		}

		if (this["oPlaceHolderRef"]) {
			UCF_DomUtil["removeFromDom"](this["oRootRef"]);
			UCF_DomUtil["removeFromDom"](this["oPlaceHolderRef"]);
			this["oPlaceHolderRef"] = null;
		}

		if (UCF_JsUtil["bIsFunction"](UCF_LayeredControl["forwardResizeEvent"])) {
			UCF_DomUtil["detachEvent"](window, 'resize', UCF_LayeredControl["forwardResizeEvent"]);
		}

		this["oChildLayer"] = null;
		this["oWindow"] = null;
		this["_oViewportObjectRect"] = null;
		this["_oVisualViewport"] = null;
		this["_iHeight"] = null;
		this["_iWidth"] = null;
		UCF_Control.prototype["destroy"]["apply"](this, arguments);
	}
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["destroy"] = 0; };

/**
 * @private
 * @return {boolean} `true` if this control identifies itself as a parent for
 * other layered controls
 */
UCF_LayeredControl["prototype"]["bIsParentLayer"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["bIsParentLayer"]++; }; 
	return this["bIsParent"];
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["bIsParentLayer"] = 0; };

/**
 * @private
 * @param {boolean} bOpen `true` to set parent layer opened
 */
UCF_LayeredControl["prototype"]["setParentLayerOpened"] = function(bOpen) {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["setParentLayerOpened"]++; }; 
	/** @type {HTMLDivElement} */
	var oAssoAreaRef = this["oLS"]["oGetAssociatedAreaRef"]();

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof bOpen === 'boolean', "typeof bOpen === 'boolean'", "LayeredControl.js(204): setParentLayerOpened"); };
	if (bOpen) {
		oAssoAreaRef["setAttribute"](UCF_LayeredControl["PARENT_LAYER_OPEN"], '1');
	} else {
		oAssoAreaRef["removeAttribute"](UCF_LayeredControl["PARENT_LAYER_OPEN"]);
	}
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["setParentLayerOpened"] = 0; };

/**
 * @private
 * @return {boolean}
 */
UCF_LayeredControl["prototype"]["bGetParentLayerOpened"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["bGetParentLayerOpened"]++; }; 
	return !!this["oLS"]["oGetAssociatedAreaRef"]()["getAttribute"](
		UCF_LayeredControl["PARENT_LAYER_OPEN"]
	);
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["bGetParentLayerOpened"] = 0; };

/**
 * Checks if the opener control has a parent that is a LayeredControl.
 * If <code>bIsParentLayer==true</code> the control instance is returned.
 * Returns null if no LayeredControl was found or if <code>bIsParentLayer()==false</code>.
 * @return {UCF_Control}
 * @private
 */
UCF_LayeredControl["prototype"]["oFindParentLayer"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["oFindParentLayer"]++; }; 

	// Do not start search if there is currently no parent layer opened
	if (this["bGetParentLayerOpened"]() === false) return null;

	var oStopAtDomRef = this["oLS"]["oGetAssociatedAreaRef"]();
	var oDom = this["oOpenerRefForLayering"] || this["oGetOpenerRef"]();

	while (oDom != null && oDom !== document["body"]) {
		if (oStopAtDomRef && oDom === oStopAtDomRef) return null;

		var oCtrl = this["oGetControlByDomRef"](oDom, false);
		if (oCtrl && UCF_JsUtil["bInstanceOf"](oCtrl, "UCF_LayeredControl") && oCtrl["bIsParentLayer"]()) {
			return oCtrl;
		}

		oDom = oDom["parentNode"];
	}
	return null;
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["oFindParentLayer"] = 0; };

/**
 * Called in handleParentLayersOnOpen() of child layer.
 * @param {UCF_LayeredControl} oChild
 * @private
 */
UCF_LayeredControl["prototype"]["registerChildLayer"] = function(oChild) {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["registerChildLayer"]++; }; 
	// Handle closing: Support only a single child (PopupMenu will close all open submenus)
	if (this["oChildLayer"] == null || this["oChildLayer"]["bAlreadyDestroyed"]) {
		this["oChildLayer"] = oChild;
	}
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["registerChildLayer"] = 0; };

/**
 * Overwrite in derived class. Called by ChildLayerDelegate
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_LayeredControl["prototype"]["notifyChildLayerMouseOver"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["notifyChildLayerMouseOver"]++; }; 
	// abstract
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["notifyChildLayerMouseOver"] = 0; };

/**
 * Overwrite in derived class. Called by ChildLayerDelegate
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_LayeredControl["prototype"]["notifyChildLayerMouseOut"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["notifyChildLayerMouseOut"]++; }; 
	// abstract
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["notifyChildLayerMouseOut"] = 0; };

/**
 * The dom reference of the opener control, that should be used for alignment.
 *
 * @param {HTMLElement} oDomRef dom object to align with
 */
UCF_LayeredControl["prototype"]["setOpenerRef"] = function(oDomRef) {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["setOpenerRef"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "LayeredControl.js(286): setOpenerRef"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "LayeredControl.js(287): setOpenerRef"); };
	this["oOpenerRef"] = oDomRef;
	// Workaround: Some control sabotage the position calculation (oGetObjectRect) by having a oDomRef element
	// with position:absolute, top:-10000, visibility:hidden (e.g. CheckBox)
	// => Use the oRootRef
	if (UCF_DomUtil["sGetCurrentStyle"](this["oOpenerRef"], 'visibility') === 'hidden') {
		var oTmp = this["oGetControlByDomRef"](this["oOpenerRef"]);
		if (oTmp) {
			this["oOpenerRef"] = oTmp["oRootRef"];
		}
	}
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["setOpenerRef"] = 0; };

/**
 * Returns the dom reference of the opener control, that should be used for parent layer calculation.
 * May be overwritten in derived class (e.g. cascading menus should not return the parent menu but the real opener).
 *
 * @return {HTMLElement} oDomRef dom object of the opener control
 */
UCF_LayeredControl["prototype"]["oGetOpenerRef"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["oGetOpenerRef"]++; }; 
	return this["oOpenerRef"];
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["oGetOpenerRef"] = 0; };

/**
 * Check position of the root ref in the DOM and replace if needed.
 * If there is an old version of the same element remove it.
 */
UCF_LayeredControl["prototype"]["checkRootRef"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["checkRootRef"]++; }; 
	var oLSRootRef = this["oLS"]["oGetRootRef"](),
		oAssoArea = this["oLS"]["oGetAssociatedAreaRef"]();
	// if the menu is alread in the associated area of page exit without adding a placeholder
	if (oLSRootRef !== oAssoArea && UCF_DomUtil["bContains"](oAssoArea, this["oRootRef"])) {
		// Exception: If it is contained inside a DIV-popup, which is located in the asso-area
		var oPopupWindow = this["oGetParentPopupWindow"](this["oRootRef"]);
		if (!(oPopupWindow && oPopupWindow["bIsDivPopup"])) return;
	}
	if (this["oRootRef"]["parentNode"] !== oLSRootRef && UCF_DomUtil["bContains"](oLSRootRef, this["oRootRef"])) {
		this["oPlaceHolderRef"] = document["createElement"]("span");
		this["oPlaceHolderRef"]["style"]["display"] = "none";
		this["oPlaceHolderRef"]["id"] = this["sId"] + "-ph";
		this["oRootRef"]["parentNode"]["replaceChild"](this["oPlaceHolderRef"], this["oRootRef"]);
		// If The iPad-FLP-IFrame-woraround of the Page is used
		// don't move the stuff to the end of the body (LSRootRef), always move into asso. area instead.
		// Because WebGUI will render PopupMenu to the Page-content that get moved AND use Sub-Menus which are rendered in the assoc-area
		// in which case the z-index handling cannot work!
		if (this["oLS"]["oGetPageInternal"]()["bInsideShellIFrameOnIOS"]()) {
			oAssoArea["appendChild"](this["oRootRef"]);
		} else {
			oLSRootRef["appendChild"](this["oRootRef"]);
		}

		if (UCF_DomUtil["bContains"](this["oRootRef"], this["oDomRef"])) {
			// All ID duplicates which can be found by getElementById have to be
			// removed from DOM see CSN 2596413 2008
			UCF_DomUtil["removePreviousIdDuplicates"](this["oRootRef"]);
		} else {
			if (__UCF_TRACE__) { UCF_Tracer.trace(WARNING, "Inconsistent oRootRef/oDomRef in control \"" + this["sId"] + "\"", "LayeredControl.js(343): checkRootRef"); };
		}
	}
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["checkRootRef"] = 0; };

/**
 * Checks if the control has a valid DOM reference.
 * This can be used for timeout methods, that may be called after the HTML
 * of the control has already been removed.
 *
 * @return {boolean} Whether the control has a valid DOM reference
 */
UCF_LayeredControl["prototype"]["bIsValid"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["bIsValid"]++; }; 
	var oDomRef = UCF_DomUtil["$"](this["sId"]),
		oRootRef = UCF_DomUtil["$"](this["sId"] + "-r"),
		oPlaceHolderRef = UCF_DomUtil["$"](this["sId"] + "-ph");
	if (!oRootRef) oRootRef = oDomRef;
	if (this["oRootRef"] !== oRootRef) return false;
	if (this["oPlaceHolderRef"]) {
		return (oPlaceHolderRef === this["oPlaceHolderRef"] && oDomRef === this["oDomRef"]);
	} else if (oDomRef) {
		return (oDomRef === this["oDomRef"]);
	}
	return false;
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["bIsValid"] = 0; };

/**
 * Returns the parent control of this LayeredControl. Special handling is needed in case a
 * placeholder is used.
 *
 * @return {UCF_Control} the parent control
 */
UCF_LayeredControl["prototype"]["oGetParent"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["oGetParent"]++; }; 
	if (!this["oParentControl"]) {
		var oDomRef = this["oPlaceHolderRef"] || this["oRootRef"];
		if (oDomRef) {
			this["oParentControl"] = this["oFindParent"](oDomRef);
		}
	}
	return this["oParentControl"];
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["oGetParent"] = 0; };

/**
 * Show the layered control
 */
UCF_LayeredControl["prototype"]["open"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["open"]++; }; 
	this["openBase"]();
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["open"] = 0; };

/**
 * Hide the layered control
 */
UCF_LayeredControl["prototype"]["close"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["close"]++; }; 
	this["closeBase"]();
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["close"] = 0; };

/**
 * Can be overwritten in the control, e.g. if it should have a drop shadow.
 * @private
 */
UCF_LayeredControl["prototype"]["addClassesOnOpen"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["addClassesOnOpen"]++; }; 
	// abstract
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["addClassesOnOpen"] = 0; };

/**
 * Call this in your "open" code if you need to overwrite the open/openBase functions !
 */
UCF_LayeredControl["prototype"]["handleParentLayersOnOpen"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["handleParentLayersOnOpen"]++; }; 
	// See internal message 2170238387
	// if (this.bParentLayerHandlerCalled) return;

	var oParentLayer = this["oFindParentLayer"]();
	if (oParentLayer) {
		// Make sure z-index is higher than parent layer
		// otherwise we would depend on the DOM order inside asso. area
		this["iChildLayerZIndex"] = parseInt(oParentLayer["oRootRef"]["style"]["zIndex"], 10) + 10;
		this["iChildLayerZIndexIncrement"] = this["iChildLayerZIndex"] - UCF_LS["E_LAYERS"]["POPUPMENUS"];
		this["oRootRef"]["style"]["zIndex"] = this["iChildLayerZIndex"];

		// Parent (e.g. QuickView) has to know the child (close)
		oParentLayer["registerChildLayer"](this);

		// Register delegate that handles mouseover/out and reports to parent layer
		this["addDelegate"](new (UCF_ClassLoader["oGetClass"]("UCF_ChildLayerDelegate"))(this["oLS"], oParentLayer));

		//this.bParentLayerHandlerCalled = true;
	}
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["handleParentLayersOnOpen"] = 0; };

/**
 * The base method for showing the layered control. This is needed because we do not
 * have the possibility to call the super implementation of a method
 * @return {boolean} Returns whether the control was actually opened (false: it may be already open or already destroyed)
 */
UCF_LayeredControl["prototype"]["openBase"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["openBase"]++; }; 

	if (this["bAlreadyDestroyed"]) {
		return false;
	}

	this["notifyLayeredControlOpen"]();
	this["handlePopupWindowLayerOpen"]();

	// Enable "re-open" (for QuickView)
	// It was kept alive during page update
	if (this["bKeepAlive"] && this["bOpened"] && UCF_DomUtil["sGetCurrentStyle"](this["oRootRef"], 'visibility') === 'hidden') {
		this["bOpened"] = false;
	}

	if (this["bOpened"]) {
		this["setPosition"]();
		return false;
	}

	this["checkRootRef"]();

	// Make it visible first, but set top:-10000 so it does not
	// enlarge the window.innerHeight in case it is moved to the end
	// of the body (by checkRootRef())
	UCF_DomUtil["setStyle"](this["oRootRef"], {
		"visibility": 'visible',
		"display": 'block',
		"overflow": 'visible',
		"top": '-10000px'
	});

	var self = this;
	UCF_LayeredControl["forwardResizeEvent"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["forwardResizeEvent"]++; }; 
		if (!self["bIsDestroyed"]) {
			self["onresize"]();
		}
	};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["forwardResizeEvent"] = 0; };
	UCF_DomUtil["attachEvent"](window, 'resize', UCF_LayeredControl["forwardResizeEvent"]);

	this["applyZIndex"]();
	this["addClassesOnOpen"]();
	this["handleParentLayersOnOpen"]();

	this["setOpened"](true);
	this["setPosition"]();
	this["notifyLayerVisible"]();
	return true;
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["openBase"] = 0; };

UCF_LayeredControl["prototype"]["applyZIndex"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["applyZIndex"]++; }; 
	if (this["oRootRef"]) {
		this["oRootRef"]["style"]["zIndex"] = this["iChildLayerZIndex"] !== -1 ? this["iChildLayerZIndex"] : UCF_LS["E_LAYERS"]["POPUPMENUS"];
	}
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["applyZIndex"] = 0; };

UCF_LayeredControl["prototype"]["handlePopupWindowLayerOpen"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["handlePopupWindowLayerOpen"]++; }; 
	if (this["bEnhancePopupWindows"]) {
		var oPopupWindow = this["oGetParentPopupWindow"](this["oOpenerRef"]);
		if (oPopupWindow && oPopupWindow["bIsIFramePopup"]()) {
			oPopupWindow["openLayeredControl"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["handlePopupWindowLayerOpen"] = 0; };

UCF_LayeredControl["prototype"]["handlePopupWindowLayerClose"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["handlePopupWindowLayerClose"]++; }; 
	if (this["bEnhancePopupWindows"]) {
		var oPopupWindow = this["oGetParentPopupWindow"](this["oOpenerRef"]);
		if (oPopupWindow && oPopupWindow["bIsIFramePopup"]()) {
			oPopupWindow["closeLayeredControl"]();
		}
	}
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["handlePopupWindowLayerClose"] = 0; };

/**
 * The base method for hiding the layered control. This is needed because we do not
 * have the possibility to call the super implementation of a method
 * @return {boolean} Return true if the control was actually closed (false: Was not open or already destroyed)
 */
UCF_LayeredControl["prototype"]["closeBase"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["closeBase"]++; }; 
	if (!this["bOpened"]) return false;

	this["handlePopupWindowLayerClose"]();

	// This is a workaround:
	// ComboBox calls ListBox.close() in its destroy() method which is a bad idea because ListBox could already be destroyed
	// because the order in LS.purgeControls() is random !
	if (this["bAlreadyDestroyed"]) {
		// Release blind-layer !
		this["setOpened"](false);

		return false;
	}

	if (UCF_JsUtil["bIsFunction"](UCF_LayeredControl["forwardResizeEvent"])) {
		UCF_DomUtil["detachEvent"](window, 'resize', UCF_LayeredControl["forwardResizeEvent"]);
	}

	UCF_DomUtil["setStyle"](this["oRootRef"], {
		// set it in the invisible part of the screen
		"top": (this["oRootRef"]["offsetHeight"] * -1) - 1,
		"visibility": 'hidden',
		"display": 'none'
	});

	this["setOpened"](false);
	this["fireEvent"](this["E_EVENTS"]["Close"]);
	this["notifyLayeredControlClose"]();
	this["notifyLayerHidden"]();

	return true;
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["closeBase"] = 0; };

UCF_LayeredControl["prototype"]["notifyLayeredControlClose"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["notifyLayeredControlClose"]++; }; 
	this["oLS"]["oBrowserWindow"]["notifyLayeredControlClose"](this["sId"], this["sClassName"]);
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["notifyLayeredControlClose"] = 0; };

UCF_LayeredControl["prototype"]["notifyLayeredControlOpen"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["notifyLayeredControlOpen"]++; }; 
	this["oLS"]["oBrowserWindow"]["notifyLayeredControlOpen"](this["sId"], this["sClassName"]);
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["notifyLayeredControlOpen"] = 0; };

/**
 * Sets the alignment type of the layered control
 *
 * @param {int} iAlignment
 */
UCF_LayeredControl["prototype"]["setAlignment"] = function(iAlignment) {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["setAlignment"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof iAlignment === 'number', "typeof iAlignment === 'number'", "LayeredControl.js(564): setAlignment"); };

	this["iAlignment"] = iAlignment;
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["setAlignment"] = 0; };

/**
 * Defines if the layered control is moved as long as it completly visible.
 * It's possible that it will overlay the opener control.
 * Default is true --> layered control is moved into the viewport
 *
 * @param { boolean } bMoveX
 * @param { boolean } bMoveY
 */
UCF_LayeredControl["prototype"]["setMoveIntoViewPortXY"] = function(bMoveX, bMoveY) {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["setMoveIntoViewPortXY"]++; }; 
	this["bMoveX"] = bMoveX;
	this["bMoveY"] = bMoveY;
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["setMoveIntoViewPortXY"] = 0; };

/**
 * Sets the pixel offset from the left that is added to the value
 * calculated by the alignment settings
 * i.e use this function if the layers should overlap the opener control
 *
 * @param {number} iPixel amount of pixels
 * @public
 */
UCF_LayeredControl["prototype"]["setOffsetLeft"] = function(iPixel) {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["setOffsetLeft"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iPixel) === "number", "typeof(iPixel) === \"number\"", "LayeredControl.js(591): setOffsetLeft"); };

	this["iOffsetLeft"] = iPixel;
	if (this["bOpened"]) {
		// move the layer if the element is already opened
		this["setPosition"]();
	}
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["setOffsetLeft"] = 0; };

/**
 * Sets the pixel offset from the top that is added to the value
 * calculated by the alignment settings.
 * i.e use this function if the layers should overlap the opener control
 *
 * @param {number} iPixel amount of pixels
 * @public
 */
UCF_LayeredControl["prototype"]["setOffsetTop"] = function(iPixel) {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["setOffsetTop"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iPixel) === "number", "typeof(iPixel) === \"number\"", "LayeredControl.js(609): setOffsetTop"); };

	this["iOffsetTop"] = iPixel;
	if (this["bOpened"]) {
		// move the layer if the element is already opened
		this["setPosition"]();
	}
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["setOffsetTop"] = 0; };

/**
 * Sets the vertical overlap of the layered control in pixel.
 * This is the amount of pixel the layered control is positioned closer to
 * the relative control than the calculated position to create an overlap (in other
 * words it is reduces the 'top' value).
 *
 * @param {number} iPixel amount of pixels
 * @public
 */
UCF_LayeredControl["prototype"]["setOverlap"] = function(iPixel) {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["setOverlap"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iPixel) === "number", "typeof(iPixel) === \"number\"", "LayeredControl.js(628): setOverlap"); };

	this["iOverlap"] = iPixel;
	if (this["bOpened"]) { //move the layer if the element is already opened
		this["setPosition"]();
	}
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["setOverlap"] = 0; };

/**
 * Set a value for the internal "move into view port" algorithm.
 * @param {int} iPixel amount of pixels
 */
UCF_LayeredControl["prototype"]["setSafetyDistance"] = function(iPixel) {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["setSafetyDistance"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iPixel) === "number", "typeof(iPixel) === \"number\"", "LayeredControl.js(641): setSafetyDistance"); };

	this["iSafetyDistance"] = iPixel;
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["setSafetyDistance"] = 0; };

/**
 * Resets internally cached values
 */
UCF_LayeredControl["prototype"]["reset"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["reset"]++; }; 
	this["_oViewportObjectRect"] = null;
	this["_oVisualViewport"] = null;

	this["iOffsetTop"] = 0;
	this["iOffsetLeft"] = 0;
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["reset"] = 0; };

/** @type {UCF_LS_VisualViewport} oVisualViewport the visual viewport */
/**
 * Returns the (visual) viewport
 * @return {UCF_LS_VisualViewport}
 */
UCF_LayeredControl["prototype"]["oGetVisualViewport"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["oGetVisualViewport"]++; }; 
	if (!this["_oVisualViewport"]) {

		this["_oVisualViewport"] = this["oLS"]["oGetVisualViewport"](this["iSafetyDistance"]);

		// If the DOM of the layered control is located in the assoc. area
		// AND the Page's iPad-FLP-IFrame-workaround is active
		// AND there is a Page margin (which is theme-dependent) ...
		// (TODO: RTL?)
		if (UCF_DomUtil["bContains"](this["oLS"]["oGetAssociatedAreaRef"](), this["oRootRef"]) &&
			this["oLS"]["oGetPageInternal"]()["bInsideShellIFrameOnIOS"]()) {
			var oTD = this["oLS"]["oGetPageInternal"]()["oGetInternalBlockLayerLocation"]();
			var sMargin = UCF_DomUtil["sGetCurrentStyle"](oTD, 'paddingLeft');
			if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'Page margin on Page TD (FLP-IFrame workaround): ' + sMargin, "LayeredControl.js(675): oGetVisualViewport"); };
			var iMargin = 0;
			if (sMargin["indexOf"]('px') > -1) iMargin = parseInt(sMargin);
			if (sMargin["indexOf"]('rem') > -1) iMargin = UCF_DomUtil["iRem2px"](sMargin);
			if (!isNaN(iMargin) && iMargin > 0) {
				this["_oVisualViewport"]["offsetLeft"] = -1 * iMargin;
			}
		}
	}

	return this["_oVisualViewport"];
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["oGetVisualViewport"] = 0; };

/**
 * Returns the object rect of the DOM node, relative to the (visual) viewport
 * @return {_ObjectRect}
 */
UCF_LayeredControl["prototype"]["oGetViewportObjectRect"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["oGetViewportObjectRect"]++; }; 
	var oOpenerRef = this["oOpenerRef"];
	var oParentPopupWindow;

	if (!this["_oViewportObjectRect"]) {
		if (!oOpenerRef) {
			// Use whole page (body or popupWindow) if there's no openerRef:
			// In iFrame PopUps the BODY may have no height...
			// then take the PopUpWindow for rect calculation
			oOpenerRef = document["getElementsByTagName"]("BODY")[0];
			oParentPopupWindow = this["oGetParentPopupWindow"]();
			if (oParentPopupWindow && !oParentPopupWindow["bIsDivPopup"]) {
				oOpenerRef = oParentPopupWindow["oDomRef"];
			}
		}
		this["_oViewportObjectRect"] = this["oLS"]["oGetViewportObjectRect"](
			oOpenerRef,
			this["oGetVisualViewport"]()
		);
	}
	return this["_oViewportObjectRect"];
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["oGetViewportObjectRect"] = 0; };

/**
 * Returns the width of the layered control
 * @return {number}
 */
UCF_LayeredControl["prototype"]["iGetWidth"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["iGetWidth"]++; }; 
	if (this["_iWidth"] === null || this["_iWidth"] === undefined) {
		this["_iWidth"] = this["oRootRef"]["scrollWidth"];
	}
	return this["_iWidth"];
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["iGetWidth"] = 0; };

/**
 * Returns the height of the layered control
 * @return {number}
 */
UCF_LayeredControl["prototype"]["iGetHeight"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["iGetHeight"]++; }; 
	if (this["_iHeight"] === null || this["_iHeight"] === undefined) {
		this["_iHeight"] = this["oRootRef"]["scrollHeight"];
	}
	return this["_iHeight"];
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["iGetHeight"] = 0; };

UCF_LayeredControl["prototype"]["iGetLeft"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["iGetLeft"]++; }; 
	/** @type {UCF_LS_VisualViewport} */
	var oVisualViewport = this["oGetVisualViewport"]();
	/** @type {_ObjectRect} */
	var oViewportObjectRect = this["oGetViewportObjectRect"]();
	/** @type {number} iWidth  the width of the layered control */
	var iWidth = this["iGetWidth"]();
	/** @type {number} iLeft  the left position of the layered control */
	var iLeft;

	// calculate the position relative to the viewport
	// horizontal alignment
	if (this["bIsRightAligned"]()) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'right-aligned, ' + UCF_JsUtil["sJsonStringify"](oViewportObjectRect) + ' width: ' + iWidth, "LayeredControl.js(750): iGetLeft"); };
		iLeft = oViewportObjectRect["left"] + oViewportObjectRect["width"] - iWidth + this["iOffsetLeft"];
	} else if (this["bIsLeftAligned"]()) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'left-aligned, ' + UCF_JsUtil["sJsonStringify"](oViewportObjectRect) + ' width: ' + iWidth, "LayeredControl.js(753): iGetLeft"); };
		iLeft = oViewportObjectRect["left"] - this["iOffsetLeft"];
	} else if (this["bIsRightAttached"]()) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'right-attached, ' + UCF_JsUtil["sJsonStringify"](oViewportObjectRect) + ' width: ' + iWidth, "LayeredControl.js(756): iGetLeft"); };
		iLeft = oViewportObjectRect["left"] + oViewportObjectRect["width"] - this["iOffsetLeft"];
	} else if (this["bIsLeftAttached"]()) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'left-attached, ' + UCF_JsUtil["sJsonStringify"](oViewportObjectRect) + ' width: ' + iWidth, "LayeredControl.js(759): iGetLeft"); };
		iLeft = oViewportObjectRect["left"] - iWidth + this["iOffsetLeft"];
	} else if (this["bIsHorizontallyCentered"]()) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'horizontally centered, ' + UCF_JsUtil["sJsonStringify"](oViewportObjectRect) + ' width: ' + iWidth, "LayeredControl.js(762): iGetLeft"); };
		iLeft = Math["floor"](oViewportObjectRect["left"] + oViewportObjectRect["width"] / 2 - iWidth / 2) + this["iOffsetLeft"];
	} else if (this["bIsHorizontallyBrowserCentered"]()) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'horizontally browser centered, ' + UCF_JsUtil["sJsonStringify"](oViewportObjectRect) + ' width: ' + iWidth, "LayeredControl.js(765): iGetLeft"); };
		iLeft = Math["floor"]((oVisualViewport["width"] - this["iGetWidth"]()) / 2);
	} else if (this["bIsFullScreen"]()) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'fullscreen, ' + UCF_JsUtil["sJsonStringify"](oViewportObjectRect) + ' width: ' + iWidth, "LayeredControl.js(768): iGetLeft"); };
		iLeft = 0;
	} else { // horizontally absolutely positioned
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'horizontally absolute positioned, ' + UCF_JsUtil["sJsonStringify"](oViewportObjectRect) + ' width: ' + iWidth, "LayeredControl.js(771): iGetLeft"); };
		iLeft = this["iLeft"] - oVisualViewport["pageLeft"];
	}
	if (this["bMoveX"] && !this["bIsFullScreen"]()) {
		iLeft = Math["max"](0, iLeft); // left
		iLeft = Math["min"](iLeft, oVisualViewport["width"] - iWidth); // right
	}

	return Math["round"](iLeft);
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["iGetLeft"] = 0; };

UCF_LayeredControl["prototype"]["iGetTop"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["iGetTop"]++; }; 
	/** @type {UCF_LS_VisualViewport} */
	var oVisualViewport = this["oGetVisualViewport"]();
	/** @type {_ObjectRect} */
	var oViewportObjectRect = this["oGetViewportObjectRect"]();
	/** @type {number} iHeight  the height of the layered control */
	var iHeight = this["iGetHeight"]();
	/** @type {number} iTop  the top position of the layered control */
	var iTop;

	if (this["bIsTopAttached"]()) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'top-attached, ' + UCF_JsUtil["sJsonStringify"](oViewportObjectRect) + ' height: ' + iHeight, "LayeredControl.js(793): iGetTop"); };
		iTop = oViewportObjectRect["top"] - iHeight - this["iOffsetTop"];
	} else if (this["bIsBottomAttached"]()) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'bottom-attached, ' + UCF_JsUtil["sJsonStringify"](oViewportObjectRect) + ' height: ' + iHeight, "LayeredControl.js(796): iGetTop"); };
		iTop = oViewportObjectRect["top"] + oViewportObjectRect["height"] + this["iOffsetTop"];
		if (this["bShowPointer"]()) {
			iTop += this["iGetPointerHeight"]();
		}
	} else if (this["bIsTopAligned"]()) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'top-aligned, ' + UCF_JsUtil["sJsonStringify"](oViewportObjectRect) + ' height: ' + iHeight, "LayeredControl.js(802): iGetTop"); };
		iTop = oViewportObjectRect["top"] - this["iOffsetTop"];
		if (this["bShowPointer"]()) {
			iTop += this["iGetPointerHeight"]();
		}
	} else if (this["bIsBottomAligned"]()) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'bottom-aligned, ' + UCF_JsUtil["sJsonStringify"](oViewportObjectRect) + ' height: ' + iHeight, "LayeredControl.js(808): iGetTop"); };
		iTop = oViewportObjectRect["top"] + oViewportObjectRect["height"] - iHeight + this["iOffsetTop"];
	} else if (this["bIsVerticallyCentered"]()) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'vertically centered, ' + UCF_JsUtil["sJsonStringify"](oViewportObjectRect) + ' height: ' + iHeight, "LayeredControl.js(811): iGetTop"); };
		iTop = Math["floor"]((oVisualViewport["height"] - this["iGetHeight"]()) / 2);
	} else if (this["bIsFullScreen"]()) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'fullscreen, ' + UCF_JsUtil["sJsonStringify"](oViewportObjectRect) + ' height: ' + iHeight, "LayeredControl.js(814): iGetTop"); };
		iTop = 0;
	} else { // vertically absolutely positioned
		if (__UCF_TRACE__) { UCF_Tracer.trace(INFO, 'vertically absolute positioned, ' + UCF_JsUtil["sJsonStringify"](oViewportObjectRect) + ' height: ' + iHeight, "LayeredControl.js(817): iGetTop"); };
		iTop = this["iTop"] - oVisualViewport["pageTop"];
	}
	if (this["bMoveY"]) {
		iTop = Math["max"](0, iTop); // top
		iTop = Math["min"](iTop, oVisualViewport["height"] - iHeight + this["iOffsetTop"]);
	}

	return Math["round"](iTop);
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["iGetTop"] = 0; };

/**
 * Updates the position of the layered control
 */
UCF_LayeredControl["prototype"]["onBeforeSetPosition"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["onBeforeSetPosition"]++; }; 
	// abstract
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["onBeforeSetPosition"] = 0; };

/**
 * Updates the position of the layered control
 */
UCF_LayeredControl["prototype"]["setPosition"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["setPosition"]++; }; 
	if (!this["bOpened"]) {
		return;
	}

	this["reset"]();
	this["onBeforeSetPosition"]();

	/** @type {UCF_LS_VisualViewport} */
	var oVisualViewport = this["oGetVisualViewport"]();

	this["iTop"] = this["iGetTop"]();
	this["iLeft"] = this["iGetLeft"]();
	this["calculatePointerPosition"]();

	if (!this["bIsFullScreen"]()) {
		this["iTop"] += oVisualViewport["pageTop"] + oVisualViewport["offsetTop"];
		this["iLeft"] += oVisualViewport["pageLeft"] + oVisualViewport["offsetLeft"];
	}

	UCF_DomUtil["setStyle"](this["oRootRef"], {
		"top": this["iTop"] + 'px',
		"left": this["iLeft"] + 'px',
		"right": null
	});

	UCF_UserAgent["setResponsiveBreakpointScope"](this["oRootRef"], this["iGetWidth"]());

	this["redrawBlindLayer"]();
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["setPosition"] = 0; };

UCF_LayeredControl["prototype"]["calculatePointerPosition"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["calculatePointerPosition"]++; }; 
	/** @type {number} iWidth  the width of the layered control */
	var iWidth;
	/** @type {HTMLElement} oPointer  reference to the pointer */
	var oPointer;
	/** @type {number} iPointerHeight  the height of the pointer */
	var iPointerHeight;
	/** @type {number} iPointerEdgeWidth  the edge width of the pointer */
	var iPointerEdgeWidth;
	/** @type {number} iMinPointerEdgeOffset  the minimal offset of the pointer from a corner */
	var iMinPointerEdgeOffset;
	/** @type {number} iPointerXPos  the resulting x-position of the pointer */
	var iPointerXPos;
	/** @type {_ObjectRect} */
	var oViewportObjectRect;
	/** @type {number} iLayeredControlLeft  the left position of the popup */
	var iLayeredControlLeft;
	/** @type {number} iLayeredControlRight  the right position of the popup */
	var iLayeredControlRight;
	/** @type {number} iMinLayeredControlWidthToHavePointer  it is not possible to display an attractive pointer for smaller layered controls */
	var iMinLayeredControlWidthToHavePointer;
	/** @type {number} iMaxLeft  the start of the region where objectRect and layered control overlap */
	var iMaxLeft;
	/** @type {number} iMinRight  the end of the region where objectRect and layered control overlap */
	var iMinRight;
	/** @type {number} iPointerYPos  the resulting x-position of the pointer */
	var iPointerYPos;
	/** @type {number} iLayeredControlTop  the top position of the layered control */
	var iLayeredControlTop;
	/** @type {number} iLayeredControlBottom  the bottom position of the layered control */
	var iLayeredControlBottom;
	/** @type {number} iMaxTop  the start of the region where objectRect and layered control overlap */
	var iMaxTop;
	/** @type {number} iMinBottom  the end of the region where objectRect and layered control overlap */
	var iMinBottom;

	oPointer = UCF_DomUtil["$"](this["sId"] + "-pointer");
	if (!this["bShowPointer"]()) {
		if (oPointer) {
			oPointer["style"]["display"] = 'none';
			oPointer["style"]["visibility"] = 'hidden';
		}
		return;
	}

	iPointerHeight = this["iGetPointerHeight"]();
	iPointerEdgeWidth = this["iGetPointerEdgeWidth"]();
	iMinPointerEdgeOffset = this["iGetMinPointerEdgeOffset"]();
	oViewportObjectRect = this["oGetViewportObjectRect"]();

	if (this["bIsTopAttached"]() || this["bIsTopAligned"]() || this["bIsBottomAttached"]() || this["bIsBottomAligned"]()) {
		iWidth = this["iGetWidth"]();
		iLayeredControlLeft = this["iLeft"];
		iLayeredControlRight = iLayeredControlLeft + iWidth;
		iMinRight = Math["min"](iLayeredControlRight, oViewportObjectRect["left"] + oViewportObjectRect["width"]);
		iMinLayeredControlWidthToHavePointer = 2 * iMinPointerEdgeOffset + 2 * iPointerHeight;
		if (
			iWidth >= iMinLayeredControlWidthToHavePointer &&
			iLayeredControlRight - oViewportObjectRect["left"] >= iMinPointerEdgeOffset &&
			oViewportObjectRect["left"] + oViewportObjectRect["width"] - iLayeredControlLeft >= iMinPointerEdgeOffset &&
			iPointerHeight > 0 &&
			!this["bMovedY"]
		) {
			iMaxLeft = Math["max"](iLayeredControlLeft, oViewportObjectRect["left"]);
			iPointerXPos = Math["round"]((iMinRight - iMaxLeft) / 2) + iMaxLeft - iLayeredControlLeft;
			iPointerXPos = Math["max"](iPointerXPos, iMinPointerEdgeOffset); // left correction, if pointer would be to close to the left edge of the layered control
			iPointerXPos = Math["min"](iPointerXPos, iWidth - iMinPointerEdgeOffset); // right correction, if pointer would be to close to the right edge of the layered control
			if (this["bIsTopAttached"]() || this["bIsBottomAligned"]()) {
				if (UCF_UserAgent["bIsIECompatibilityMode"]()) {
					UCF_DomUtil["addClass"](oPointer, 'lsQVArrowDownIEQ');
					oPointer["style"]["position"] = 'absolute';
					oPointer["style"]["width"] = '100%';
					oPointer["style"]["top"] = (this["iGetHeight"]() - iPointerHeight - 1) + 'px';
					oPointer["style"]["left"] = (iPointerXPos - iPointerHeight) + 'px';
				} else {
					oPointer["style"]["top"] = '';
					oPointer["style"]["bottom"] = (-1 * iPointerEdgeWidth / 2) + 'px';
					oPointer["style"]["left"] = (iPointerXPos - iPointerEdgeWidth / 2) + 'px';
					oPointer["style"]["transformOrigin"] = 'center';
					oPointer["style"]["transform"] = 'rotate(-135deg)';
				}
			} else {
				this["iOverlap"] = -1 * iPointerHeight;
				if (UCF_UserAgent["bIsIECompatibilityMode"]()) {
					UCF_DomUtil["addClass"](oPointer, 'lsQVArrowUpIEQ');
					oPointer["style"]["position"] = 'absolute';
					oPointer["style"]["width"] = '100%';
					oPointer["style"]["top"] = (-1 * iPointerHeight + 1) + 'px';
					oPointer["style"]["left"] = (iPointerXPos - iPointerHeight) + 'px';
				} else {
					oPointer["style"]["top"] = (-1 * iPointerEdgeWidth / 2) + 'px';
					oPointer["style"]["bottom"] = '';
					oPointer["style"]["left"] = (iPointerXPos - iPointerEdgeWidth / 2) + 'px';
					oPointer["style"]["transformOrigin"] = 'center';
					oPointer["style"]["transform"] = 'rotate(45deg)';
				}
			}
			oPointer["style"]["display"] = '';
			oPointer["style"]["visibility"] = 'visible';
		} else {
			oPointer["style"]["display"] = 'none';
			oPointer["style"]["visibility"] = 'hidden';
		}
	}

	if (this["bIsRightAttached"]() || this["bIsLeftAttached"]()) {
		iLayeredControlTop = this["iTop"] - this["oGetVisualViewport"]()["pageTop"];
		iLayeredControlBottom = iLayeredControlTop + this["iGetHeight"]();
		iMinBottom = Math["min"](iLayeredControlBottom, oViewportObjectRect["top"] + oViewportObjectRect["height"]);
		iMaxTop = Math["max"](iLayeredControlTop, oViewportObjectRect["top"]);
		if (iMinBottom >= iMaxTop && iPointerHeight > 0 && !this["bMovedX"]) {
			iPointerYPos = Math["round"]((iMinBottom - iMaxTop) / 2) + iMaxTop - iLayeredControlTop;
			if (this["bIsRightAttached"]()) {
				oPointer["style"]["top"] = iPointerYPos + 'px';
				oPointer["style"]["left"] = (-1 * iPointerHeight) + 'px';
				oPointer["style"]["transformOrigin"] = 'top left';
				oPointer["style"]["transform"] = 'rotate(-45deg)';
			} else {
				oPointer["style"]["top"] = iPointerYPos + 'px';
				oPointer["style"]["right"] = (-1 * (iPointerEdgeWidth + iPointerHeight)) + 'px';
				oPointer["style"]["transformOrigin"] = 'top left';
				oPointer["style"]["transform"] = 'rotate(135deg)';
			}
			oPointer["style"]["display"] = '';
			oPointer["style"]["visibility"] = 'visible';
		} else {
			oPointer["style"]["display"] = 'none';
			oPointer["style"]["visibility"] = 'hidden';
		}
	}

	this["onAfterPointerCalculation"](oPointer);
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["calculatePointerPosition"] = 0; };

UCF_LayeredControl["prototype"]["onAfterPointerCalculation"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["onAfterPointerCalculation"]++; }; 
	//abstract
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["onAfterPointerCalculation"] = 0; };

/**
 * Returns whether the pointer for the layered control shall be displayed:
 * Per default, it shall not be displayed, but derived controls (like quickview
 * and popupmenu) can overwrite this
 * @return {boolean}
 */
UCF_LayeredControl["prototype"]["bShowPointer"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["bShowPointer"]++; }; 
	return false;
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["bShowPointer"] = 0; };

/**
 * Returns the height of the pointer
 * @return {number}
 */
UCF_LayeredControl["prototype"]["iGetPointerHeight"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["iGetPointerHeight"]++; }; 
	var iPointerEdgeWidth = this["iGetPointerEdgeWidth"]();

	return Math["floor"](Math["sqrt"](iPointerEdgeWidth * iPointerEdgeWidth * 2) / 2);
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["iGetPointerHeight"] = 0; };

/**
 * Returns the edge width of the pointer:
 * Per default, there is no pointer displayed and the edge width is 0 therefore.
 * But derived controls (like quickview and popupmenu) can overwrite this.
 * @return {number}
 */
UCF_LayeredControl["prototype"]["iGetPointerEdgeWidth"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["iGetPointerEdgeWidth"]++; }; 
	return this["bShowPointer"]() ? 0.75 * 16 : 0; // rem * 16 = 12px
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["iGetPointerEdgeWidth"] = 0; };

/**
 * Returns the minimum distance from the pointer to the edge of the layeres control
 * @return {number}
 */
UCF_LayeredControl["prototype"]["iGetMinPointerEdgeOffset"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["iGetMinPointerEdgeOffset"]++; }; 
	return 2 * this["iGetPointerHeight"]();
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["iGetMinPointerEdgeOffset"] = 0; };

/**
 * @protected
 * @return {boolean}
 */
UCF_LayeredControl["prototype"]["bIsTopOrBottom"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["bIsTopOrBottom"]++; }; 
	return !(this["iAlignment"] === UCF_LayeredControl["ALIGNMENT"]["MENUITEM"] ||
		this["iAlignment"] === UCF_LayeredControl["ALIGNMENT"]["RIGHT"]);
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["bIsTopOrBottom"] = 0; };

/**
 * @protected
 * @return {boolean}
 */
UCF_LayeredControl["prototype"]["bIsLeftAligned"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["bIsLeftAligned"]++; }; 
	return window["UCF_System"]["bIsRTL"]
		? (this["iAlignment"] === UCF_LayeredControl["ALIGNMENT"]["TOPRIGHT"] ||
			this["iAlignment"] === UCF_LayeredControl["ALIGNMENT"]["BOTTOMRIGHT"] ||
			this["iAlignment"] === UCF_LayeredControl["ALIGNMENT"]["TOPRIGHT_CONTAINER"])
		: (this["iAlignment"] === UCF_LayeredControl["ALIGNMENT"]["TOPLEFT"] ||
			this["iAlignment"] === UCF_LayeredControl["ALIGNMENT"]["BOTTOMLEFT"] ||
			this["iAlignment"] === UCF_LayeredControl["ALIGNMENT"]["TOPLEFT_CONTAINER"]);
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["bIsLeftAligned"] = 0; };

/**
 * @protected
 * @return {boolean}
 */
UCF_LayeredControl["prototype"]["bIsRightAligned"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["bIsRightAligned"]++; }; 
	return window["UCF_System"]["bIsRTL"]
		? (this["iAlignment"] === UCF_LayeredControl["ALIGNMENT"]["TOPLEFT"] ||
			this["iAlignment"] === UCF_LayeredControl["ALIGNMENT"]["BOTTOMLEFT"] ||
			this["iAlignment"] === UCF_LayeredControl["ALIGNMENT"]["TOPLEFT_CONTAINER"])
		: (this["iAlignment"] === UCF_LayeredControl["ALIGNMENT"]["TOPRIGHT"] ||
			this["iAlignment"] === UCF_LayeredControl["ALIGNMENT"]["BOTTOMRIGHT"] ||
			this["iAlignment"] === UCF_LayeredControl["ALIGNMENT"]["TOPRIGHT_CONTAINER"]);
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["bIsRightAligned"] = 0; };

/**
 * @protected
 * @return {boolean}
 */
UCF_LayeredControl["prototype"]["bIsLeftAttached"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["bIsLeftAttached"]++; }; 
	return (this["iAlignment"] === UCF_LayeredControl["ALIGNMENT"]["MENUITEM"] ||
			this["iAlignment"] === UCF_LayeredControl["ALIGNMENT"]["RIGHT"]) &&
		!this["bIsRightAttached"]();
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["bIsLeftAttached"] = 0; };

/**
 * @protected
 * @return {boolean}
 */
UCF_LayeredControl["prototype"]["bIsRightAttached"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["bIsRightAttached"]++; }; 
	/** @type {_ObjectRect} */
	var oViewportObjectRect = this["oGetViewportObjectRect"]();
	/** @type {number} iWidth  the width of the layered control */
	var iWidth = this["iGetWidth"]();

	return window["UCF_System"]["bIsRTL"]
		? (
			(this["iAlignment"] === UCF_LayeredControl["ALIGNMENT"]["MENUITEM"] ||
				this["iAlignment"] === UCF_LayeredControl["ALIGNMENT"]["RIGHT"]) &&
			oViewportObjectRect["left"] < iWidth &&
			oViewportObjectRect["right"] >= iWidth
		)
		: (
			(this["iAlignment"] === UCF_LayeredControl["ALIGNMENT"]["MENUITEM"] ||
				this["iAlignment"] === UCF_LayeredControl["ALIGNMENT"]["RIGHT"]) &&
			(oViewportObjectRect["right"] >= iWidth ||
				oViewportObjectRect["left"] < iWidth)
		);
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["bIsRightAttached"] = 0; };

/**
 * @protected
 * @return {boolean}
 */
UCF_LayeredControl["prototype"]["bIsTopAligned"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["bIsTopAligned"]++; }; 
	/** @type {_ObjectRect} */
	var oViewportObjectRect = this["oGetViewportObjectRect"]();
	/** @type {number} iHeight  the height of the layered control */
	var iHeight = this["iGetHeight"]();

	return (
			this["iAlignment"] === UCF_LayeredControl["ALIGNMENT"]["MENUITEM"] ||
			this["iAlignment"] === UCF_LayeredControl["ALIGNMENT"]["TOPLEFT_CONTAINER"] ||
			this["iAlignment"] === UCF_LayeredControl["ALIGNMENT"]["TOPRIGHT_CONTAINER"]
		)
		&&
		(
			oViewportObjectRect["height"] + oViewportObjectRect["bottom"] >= iHeight ||
			oViewportObjectRect["top"] < iHeight
		);
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["bIsTopAligned"] = 0; };

/**
 * @protected
 * @return {boolean}
 */
UCF_LayeredControl["prototype"]["bIsBottomAligned"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["bIsBottomAligned"]++; }; 
	/** @type {_ObjectRect} */
	var oViewportObjectRect = this["oGetViewportObjectRect"]();
	/** @type {number} iHeight  the height of the layered control */
	var iHeight = this["iGetHeight"]();

	return this["iAlignment"] === UCF_LayeredControl["ALIGNMENT"]["MENUITEM"]
		&& oViewportObjectRect["height"] + oViewportObjectRect["bottom"] < iHeight
		&& oViewportObjectRect["top"] + oViewportObjectRect["height"] >= iHeight;
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["bIsBottomAligned"] = 0; };

/**
 * @protected
 * @return {boolean}
 */
UCF_LayeredControl["prototype"]["bIsTopAttached"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["bIsTopAttached"]++; }; 
	/** @type {_ObjectRect} */
	var oViewportObjectRect = this["oGetViewportObjectRect"]();
	/** @type {number} iHeight  the height of the layered control */
	var iHeight = this["iGetHeight"]();

	return (
		( // TOP-attached set and there is enough space above or not enough space below; open above
			(
				this["iAlignment"] === UCF_LayeredControl["ALIGNMENT"]["TOPLEFT"] ||
				this["iAlignment"] === UCF_LayeredControl["ALIGNMENT"]["TOPRIGHT"] ||
				this["iAlignment"] === UCF_LayeredControl["ALIGNMENT"]["TOPCENTER"]
			)
			&& (oViewportObjectRect["top"] >= iHeight || oViewportObjectRect["bottom"] < iHeight)
		)
		||
		( // BOTTOM-attached set and there is not enough space below, but above: open above
			(
				this["iAlignment"] === UCF_LayeredControl["ALIGNMENT"]["BOTTOMLEFT"] ||
				this["iAlignment"] === UCF_LayeredControl["ALIGNMENT"]["BOTTOMRIGHT"] ||
				this["iAlignment"] === UCF_LayeredControl["ALIGNMENT"]["BOTTOMCENTER"]
			)
			&& oViewportObjectRect["bottom"] < iHeight && oViewportObjectRect["top"] >= iHeight
		)
		||
		( // TOP-aligned set and there is not enough space below, but above: open above
			(
				this["iAlignment"] === UCF_LayeredControl["ALIGNMENT"]["TOPLEFT_CONTAINER"] ||
				this["iAlignment"] === UCF_LayeredControl["ALIGNMENT"]["TOPRIGHT_CONTAINER"]
			)
			&& oViewportObjectRect["iHeight"] + oViewportObjectRect["bottom"] < iHeight && oViewportObjectRect["top"] >= iHeight
		)
	);
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["bIsTopAttached"] = 0; };

/**
 * @protected
 * @return {boolean}
 */
UCF_LayeredControl["prototype"]["bIsBottomAttached"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["bIsBottomAttached"]++; }; 
	/** @type {_ObjectRect} */
	var oViewportObjectRect = this["oGetViewportObjectRect"]();
	/** @type {number} iHeight  the height of the layered control */
	var iHeight = this["iGetHeight"]();

	return (
		( // BOTTOM-attached set and there is enough space below or not enough space above: open below
			(
				this["iAlignment"] === UCF_LayeredControl["ALIGNMENT"]["BOTTOMLEFT"] ||
				this["iAlignment"] === UCF_LayeredControl["ALIGNMENT"]["BOTTOMRIGHT"] ||
				this["iAlignment"] === UCF_LayeredControl["ALIGNMENT"]["BOTTOMCENTER"]
			)
			&& (oViewportObjectRect["bottom"] >= iHeight || oViewportObjectRect["top"] < iHeight)
		)
		||
		( // TOP-attached set and there is not enough space above, but below: open below
			(
				this["iAlignment"] === UCF_LayeredControl["ALIGNMENT"]["TOPLEFT"] ||
				this["iAlignment"] === UCF_LayeredControl["ALIGNMENT"]["TOPRIGHT"] ||
				this["iAlignment"] === UCF_LayeredControl["ALIGNMENT"]["TOPCENTER"]
			)
			&& oViewportObjectRect["top"] < iHeight && oViewportObjectRect["bottom"] >= iHeight
		)
	);
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["bIsBottomAttached"] = 0; };

/**
 * @protected
 * @return {boolean}
 */
UCF_LayeredControl["prototype"]["bIsHorizontallyCentered"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["bIsHorizontallyCentered"]++; }; 
	return (
		this["iAlignment"] === UCF_LayeredControl["ALIGNMENT"]["TOPCENTER"] ||
		this["iAlignment"] === UCF_LayeredControl["ALIGNMENT"]["BOTTOMCENTER"]
	);
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["bIsHorizontallyCentered"] = 0; };

/**
 * @protected
 * @return {boolean}
 */
UCF_LayeredControl["prototype"]["bIsHorizontallyBrowserCentered"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["bIsHorizontallyBrowserCentered"]++; }; 
	return this["iAlignment"] === UCF_LayeredControl["ALIGNMENT"]["BROWSERCENTER"];
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["bIsHorizontallyBrowserCentered"] = 0; };

/**
 * @protected
 * @return {boolean}
 */
UCF_LayeredControl["prototype"]["bIsVerticallyCentered"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["bIsVerticallyCentered"]++; }; 
	return this["iAlignment"] === UCF_LayeredControl["ALIGNMENT"]["BROWSERCENTER"];
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["bIsVerticallyCentered"] = 0; };

/**
 * @protected
 * @return {boolean}
 */
UCF_LayeredControl["prototype"]["bIsFullScreen"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["bIsFullScreen"]++; }; 
	return this["iAlignment"] === UCF_LayeredControl["ALIGNMENT"]["OVERLAY"];
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["bIsFullScreen"] = 0; };

/**
 * Sets the left postion
 *
 * @param {int} iLeft
 */
UCF_LayeredControl["prototype"]["setLeft"] = function(iLeft) {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["setLeft"]++; }; 
	this["iLeft"] = iLeft;
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["setLeft"] = 0; };

/**
 * Sets the top postion
 *
 * @param {int} iTop
 */
UCF_LayeredControl["prototype"]["setTop"] = function(iTop) {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["setTop"]++; }; 
	this["iTop"] = iTop;
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["setTop"] = 0; };

/**
 * Redraws the blind layer of the layered control
 */
UCF_LayeredControl["prototype"]["redrawBlindLayer"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["redrawBlindLayer"]++; }; 
	if (!this["oBlindLayer"])
		this["oBlindLayer"] = this["oLS"]["oGetBlindLayer"]();

	UCF_DomUtil["setStyle"](this["oBlindLayer"]["oDomRef"], {
		"left": this["iLeft"] + 'px',
		"top": this["iTop"] + 'px',
		// This "clean-up" resulted in issue with height on IE !
		// Please don't clean-up again.
		// width: this.iGetWidth() + 'px',
		// height: this.iGetHeight() + 'px'
		"width": this["oRootRef"]["scrollWidth"] + 'px',
		"height": this["oRootRef"]["scrollHeight"] + 'px'
	});
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["redrawBlindLayer"] = 0; };

/**
 * On a resize the position has to be adopted
 * (resize will be fired for orientation change as well)
 */
UCF_LayeredControl["prototype"]["onresize"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["onresize"]++; }; 
	if (!this["bIsValid"]()) return;
	this["onBeforeResize"]();
	this["setPosition"]();
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["onresize"] = 0; };

/**
 * Hook for Listbox_Popup
 */
UCF_LayeredControl["prototype"]["onBeforeResize"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["onBeforeResize"]++; }; 
	// abstract
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["onBeforeResize"] = 0; };

/**
 * Set open state of the layer
 * @param {boolean} bOpened
 *
 */
UCF_LayeredControl["prototype"]["setOpened"] = function(bOpened) {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["setOpened"]++; }; 
	this["bOpened"] = bOpened;
	if (!bOpened) {
		if (this["oBlindLayer"]) {
			this["oLS"]["releaseBlindLayer"](this["oBlindLayer"]);
			this["oBlindLayer"] = null;
		}
	} else {
		if (!this["oBlindLayer"])
			this["oBlindLayer"] = this["oLS"]["oGetBlindLayer"]();
	}
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["setOpened"] = 0; };

/**
 * Returns whether the control is opened to the top of its opener
 * or to the bottom
 * @return {boolean}
 */
UCF_LayeredControl["prototype"]["bOpenedOnTop"] = function() {;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["bOpenedOnTop"]++; }; 
	return this["iOpenYDirection"] === -1;
};;if (__UCF_COVERAGE__) { UCF_LayeredControl["_"]["bOpenedOnTop"] = 0; };

UCF_LayeredControl.prototype["aPublicMethods"] = ["setOffsetLeft","setOffsetTop","setOverlap"].concat(UCF_LayeredControl.prototype.aPublicMethods || []);
};